import { Link } from 'react-router-dom';
import { ArrowRight, PlayCircle, Rocket } from 'lucide-react';
import { useActivationSteps } from '../../hooks/useActivationSteps';

interface Props {
  onShowWalkthrough?: () => void;
}

export function AanDeSlagRow({ onShowWalkthrough }: Props) {
  const { nextStep, doneCount, steps, loading, error, allDone } = useActivationSteps();
  if (loading || error || allDone || !nextStep) return null;
  return (
    <Link
      to="/aan-de-slag"
      className="flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-4 py-3 mb-6 hover:border-[#FF6B35] transition-colors group"
    >
      <span className="flex-none w-9 h-9 rounded-full bg-[#FF6B35]/10 text-[#FF6B35] flex items-center justify-center">
        <Rocket className="w-5 h-5" />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-xs text-gray-500">Aan de slag · {doneCount}/{steps.length} klaar</span>
        <span className="block text-sm font-semibold text-[#231F20] truncate">Je volgende stap: {nextStep.title}</span>
      </span>
      {onShowWalkthrough && (
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onShowWalkthrough(); }}
          className="flex-none inline-flex items-center gap-1.5 text-xs font-semibold text-[#FF6B35] hover:text-[#e85a20] transition-colors"
        >
          <PlayCircle className="w-4 h-4" />
          <span className="hidden md:inline">Bekijk de rondleiding</span>
        </button>
      )}
      <ArrowRight className="flex-none w-5 h-5 text-gray-400 group-hover:text-[#FF6B35] transition-colors" />
    </Link>
  );
}
